// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vis-cf-iconpicker{position:relative}.vis-cf-iconpicker__flyout{padding:0.3em;width:110px;flex-wrap:wrap;display:flex;justify-content:flex-start;-ms-high-contrast-adjust:none}.vis-cf-iconpicker__cell{display:inline-block;width:16px;height:16px;margin:8px}.vis-cf-iconpicker__cell:hover{cursor:pointer}.vis-cf-iconpicker__text{width:100%;height:100%;text-align:center}.vis-cf-iconpicker__text:hover{cursor:pointer}\n", ""]);
// Exports
module.exports = exports;
